// @ts-nocheck
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { FormFieldUploadedFileType } from "@store/Framework/Types/FormField";

const baseUrl = "/api/v1/custom/forms";

export interface SubmitSimpleQuoteFormApiParameter extends ApiParameter {
    estimatedAnnualQuantity?: string;
    attachments?: FormFieldUploadedFileType[];
    emailAddress: string;
    firstName: string;
    lastName: string;
    requestDetails: string;
    phoneNumber?: string;
    productType: string;
    referenceProductId?: string;
    soldToNumber: string;
    shipToNumber: string;
}

export interface SubmitSimpleQuoteFormModel {
    success: boolean;
}

export async function submitSimpleQuoteForm(
    parameter: SubmitSimpleQuoteFormApiParameter,
): Promise<ServiceResult<SubmitSimpleQuoteFormModel>> {
    try {
        const result = await post<SubmitSimpleQuoteFormApiParameter, SubmitSimpleQuoteFormModel>(
            `${baseUrl}/quoterequest`,
            parameter,
        );

        return { successful: true, result };
    } catch (error) {
        return { successful: false, errorMessage: "" };
    }
}
